import React, { useState } from 'react';
import { Row, Form, Modal, DatePicker, notification } from 'antd';
import { useSelector } from 'react-redux';
import { getOrdersFromShipment } from 'store/requests/order';
import FormItem from 'antd/es/form/FormItem';
import { useTranslation } from 'react-i18next';
import { DateFormat, EXPORT_LIMIT, ITEM_TYPE_ORDERS } from 'helpers/constants';

const { RangePicker } = DatePicker;
const ExportOrderData = (props) => {
  const { setOpenDateModal, columns } = props;
  const { t } = useTranslation();
  const [orderDateForm] = Form.useForm();
  const activeStoreId = useSelector(
    (state) => state.auth?.user.activeStore?.id,
  );
  const activeRegionId = useSelector(
    (state) => state.auth?.user.activeRegion?.id,
  );
  const [loading, setLoading] = useState(false);

  const orderTypeMap = {
    [ITEM_TYPE_ORDERS.regularOrder]: t('regularOrder'),
    [ITEM_TYPE_ORDERS.changeOrder]: t('changeOrder'),
    [ITEM_TYPE_ORDERS.returnPickup]: t('returnPickup'),
  };
  const onFinish = async (values) => {
    setLoading(true);
    const [startDate, endDate] = values.date;
    if (!startDate && !endDate) {
      return;
    }

    const startDateAndTime = `${startDate.format(DateFormat.YearDateFormat)}T00:00`;
    const finishDateAndTime = `${endDate.format(DateFormat.YearDateFormat)}T00:00`;

    let queryString = activeStoreId
      ? `filter=slot.zone.store.id==${activeStoreId}`
      : `filter=slot.zone.store.region.id==${activeRegionId}`;

    queryString += ` and externalCreateTime=ge=${startDateAndTime} and externalCreateTime=le=${finishDateAndTime}&size=20000`;

    const orderRes = await getOrdersFromShipment(queryString);
    const rows = orderRes?._embedded?.orderResponseDtoList ?? [];

    if (rows.length > EXPORT_LIMIT) {
      notification.warn({
        message: t('warning'),
        description: t('orderCountLimitExceed'),
      });
      return;
    }

    if (rows.length > 0) {
      const csvData = [
        columns.map((item) => item.title),
        ...rows.map((item) => [
          item.customerOrderNumber,
          item.partner,
          t(item.orderStatus),
          item.timeSlot,
          item.address ? item.address.text: '',
          item.externalCreateTime.replace('T', ' '),
          item.deliveryDate,
          item.slot ? item.slot.zone.store.name : '',
          orderTypeMap[item.orderType] || '-',
        ]),
      ];

      handleCSVDownload(csvData);
    }

    setOpenDateModal(false);
    setLoading(false);
  };

  const handleCSVDownload = (csvData) => {
    const csvContent =
      'data:text/csv;charset=utf-8,' +
      csvData.map((row) => row.join(';')).join('\n');
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'Orders.csv');
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
  };

  return (
    <>
      <Modal
        centered
        closable
        open={true}
        maskClosable={false}
        onOk={() => {
          orderDateForm.submit();
        }}
        onCancel={() => setOpenDateModal(false)}
        title={t('dateRangeForOrder')}
        okText={t('download')}
        cancelText={t('cancel')}
        okButtonProps={{ loading: loading }}
      >
        <Row gutter={20}>
          <Form
            style={{ width: '100%' }}
            labelCol={{ span: 12 }}
            wrapperCol={{ span: 24 }}
            name="basic"
            onFinish={onFinish}
            form={orderDateForm}
          >
            <FormItem
              rules={[
                {
                  required: true,
                  message: t('alert.fillField'),
                },
              ]}
              name="date"
            >
              <RangePicker
                placeholder={[
                  t('placeholder.startDate'),
                  t('placeholder.endDate'),
                ]}
                style={{ width: '100%' }}
                format={DateFormat.DayDateFormat}
              />
            </FormItem>
          </Form>
        </Row>
      </Modal>
    </>
  );
};

export default ExportOrderData;
